import React from "react";
import { Dropdown, Menu, Space } from "antd";
import {
  DownOutlined,
  FileTextOutlined,
  SafetyOutlined,
  HomeOutlined,
} from "@ant-design/icons";
import { Link } from "react-router-dom";
import { useLanguage, Language } from "./LanguageContext";

export const TopMenu: React.FC = () => {
  const { language, setLanguage, t } = useLanguage();
  const isRtl = language === "fa" || language === "ar";

  const languages = [
    { code: "en", flag: "🇺🇸", name: "English" },
    { code: "ar", flag: "🇸🇦", name: "العربية" },
    { code: "fa", flag: "🇮🇷", name: "فارسی" },
    { code: "ko", flag: "🇰🇷", name: "한국어" },
    { code: "de", flag: "🇩🇪", name: "Deutsch" },
    { code: "fr", flag: "🇫🇷", name: "Français" },
    { code: "ru", flag: "🇷🇺", name: "Русский" },
    { code: "zh", flag: "🇨🇳", name: "中文" },
    { code: "ja", flag: "🇯🇵", name: "日本語" },
    { code: "it", flag: "🇮🇹", name: "Italiano" },
    { code: "tr", flag: "🇹🇷", name: "Türkçe" },
  ];

  const currentLang =
    languages.find((lang) => lang.code === language) || languages[0];

  const languageMenu = (
    <Menu
      onClick={({ key }) => setLanguage(key as Language)}
      style={{
        background: "rgba(255, 255, 255, 0.95)",
        backdropFilter: "blur(10px)",
        borderRadius: "8px",
        border: "none",
        boxShadow: "0 4px 16px rgba(0, 0, 0, 0.1)",
      }}
    >
      {languages.map((lang) => (
        <Menu.Item key={lang.code}>
          <Space>
            <span>{lang.flag}</span>
            <span>{lang.name}</span>
          </Space>
        </Menu.Item>
      ))}
    </Menu>
  );

  const menuItems = [
    {
      key: "home",
      icon: <HomeOutlined style={{ padding: "0 5px" }} />,
      label: (
        <Link to="/" style={{ color: "inherit", textDecoration: "none" }}>
          {t("menuHome")}
        </Link>
      ),
    },
    {
      key: "placement-test",
      icon: <FileTextOutlined style={{ padding: "0 5px" }} />,
      label: (
        <Link
          to="/placement-test?l=en-us"
          style={{ color: "inherit", textDecoration: "none" }}
        >
          {t("menuPlacementTest")}
        </Link>
      ),
    },
    {
      key: "privacy",
      icon: <FileTextOutlined style={{ padding: "0 5px" }} />,
      label: (
        <Link
          to="/privacy"
          style={{ color: "inherit", textDecoration: "none" }}
        >
          {t("menuPrivacyPolicy")}
        </Link>
      ),
    },
    {
      key: "safety",
      icon: <SafetyOutlined style={{ padding: "0 5px" }} />,
      label: (
        <Link to="/safety" style={{ color: "inherit", textDecoration: "none" }}>
          {t("menuSafetySecurity")}
        </Link>
      ),
    },
    {
      key: "language",
      label: (
        <Dropdown
          overlay={languageMenu}
          trigger={["click"]}
          placement="bottomRight"
        >
          <span style={{ color: "inherit", cursor: "pointer" }}>
            <Space>
              <span>{currentLang.flag}</span>
              <span>{currentLang.name}</span>
              <DownOutlined style={{ fontSize: "12px" }} />
            </Space>
          </span>
        </Dropdown>
      ),
    },
  ];

  return (
    <div
      style={{
        background: "rgba(255, 255, 255, 0.1)",
        backdropFilter: "blur(20px)",
        borderBottom: "1px solid rgba(255, 255, 255, 0.2)",
        padding: "12px 0",
        position: "sticky",
        top: 0,
        zIndex: 1000,
        direction: isRtl ? "rtl" : "ltr",
        boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
      }}
    >
      <div style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 24px" }}>
        <Menu
          mode="horizontal"
          items={menuItems}
          style={{
            background: "transparent",
            border: "none",
            fontSize: "15px",
            fontWeight: "600",
            direction: isRtl ? "rtl" : "ltr",
          }}
        />
      </div>
    </div>
  );
};
